import React, { useState, useEffect, forwardRef } from "react";
import { Accordion, AccordionSummary, AccordionDetails, Box, Typography } from "@mui/material";
import { capitalize, getVariantTotal } from "../../common/util";
import { ExpandMoreOutlined } from "@mui/icons-material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import currency from "currency.js";

const VariantSelectionCategory = forwardRef(function VariantSelectionCategory(props, ref) {
  const { field, cat, variant, dontCollapseOnSelect, basePrice } = props;
  const [expanded, setExpanded] = useState(true);

  useEffect(() => {
    if (!dontCollapseOnSelect && isFilledOut()) {
      setExpanded(false);
    }
  }, [variant]);

  const isFilledOut = () => {
    if (variant) {
      if (+field?.max > 1) {
        if (variant.value && Array.isArray(variant.value)) {
          if (variant.value?.length >= +field?.max) {
            return true;
          }
        }
      } else {
        return Boolean(variant.value);
      }
    }
    return false;
  };

  const isDone = props.complete !== undefined ? Boolean(props.complete) : isFilledOut();
  let bgColor = "#ECECEC";

  let header = (
    <Typography variant={expanded ? "h5" : "subtitle1"}>
      {props.placeholderLabel || `Select ${capitalize(cat)}`}
    </Typography>
  );
  if (variant?.name) {
    let surcharge = getVariantTotal(variant, basePrice);
    if (!surcharge && variant?.pricing) {
      if (variant.pricing.amount) {
        surcharge = +variant.pricing.amount;
      } else if (+basePrice > 0 && +variant.pricing.factor) {
        surcharge = currency(basePrice).multiply(variant.pricing.factor).value;
      }
    }
    header = (
      <Box style={{ display: "flex", alignItems: "center", gap: "7px" }}>
        <CheckCircleIcon style={{ fontSize: "1.3rem", color: "#1abc9c" }} />
        <Typography variant="overline" sx={{ color: "#777" }}>
          {cat}
        </Typography>
        <Typography sx={{ color: "#CCC" }}>|</Typography>
        <Typography variant="body1" sx={{ textTransform: "capitalize" }}>
          {variant.name} {+surcharge > 0 ? ` • +${currency(surcharge).format()}` : ""}
        </Typography>
      </Box>
    );
  }

  if (expanded) {
    bgColor = "#FFF";
  }
  if (isDone) {
    bgColor = "#eafaf1";
  }

  return (
    <div
      ref={ref}
      style={
        expanded
          ? { marginTop: "15px", marginBottom: "15px" }
          : { borderBottom: "1px solid #ECECEC" }
      }
    >
      <Accordion
        elevation={0}
        expanded={expanded}
        onChange={(evt, nextExpanded) => setExpanded(nextExpanded)}
      >
        <AccordionSummary expandIcon={<ExpandMoreOutlined />}>{header}</AccordionSummary>
        <AccordionDetails>{props.children}</AccordionDetails>
      </Accordion>
    </div>
  );
});

export default VariantSelectionCategory;
